<script setup>
import { useModalStore } from '../../store/modal'
const modalStore = useModalStore()

const props = defineProps({
    icon: {
        type: String,
        required: true,
        default: 'exclaim-default'
    },
    heading: {
        type: String,
        required: true,
        default: 'Default Modal'
    },
    description: {
        type: [String, null],
        required: false,
        default: ""
    },
    subtext: {
        type: [String, null],
        required: false,
        default: ""
    },
    error: {
        type: [String, null],
        required: false,
        default: ""
    },
    loading: {
        type: Boolean,
        required: false,
        default: false
    },
    refresh: {
        type: Boolean,
        required: false,
        default: false
    }
})
</script>

<template>
    <div class="modal-base">
        <button class="modal-base-close-button" @click="modalStore.close(refresh)">
            <ah-icon name="cross-default" :size="20"/>
        </button>
        <div class="modal-base-body" v-if="loading">
<!--            TODO: add loading state-->
            <div class="modal-loader"></div>
        </div>
        <div class="modal-base-body" v-else>
            <div class="modal-base-heading">
                <div class="modal-base-heading-icon">
                    <ah-icon :name="icon" />
                </div>

                <div class="modal-base-heading-headings">
                    <h1>{{heading}}</h1>
                    <p class="default-modal-error" v-if="error"> {{error}}</p>
                    <h2 class="default-modal-description" v-if="description">{{ description }}</h2>
                    <p v-if="subtext">{{subtext}}</p>
                </div>
            </div>
            <div class="modal-body-content">
                <slot />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.modal-base {
    width: min(37.5rem, 100%);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 1rem;
    margin: 0 4rem 4rem 0;

    .modal-base-close-button {
        width: 3.6rem;
        height: 3.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: transparent;
        border: none;
        outline: none;

        .icon {
            fill: var(--color-white);
            cursor: pointer;
        }

        &:hover {
            background: var(--color-red-raspberry);
        }
    }

    .modal-base-body {
        padding: 3rem 1rem;
        width: 100%;
        background: var(--color-white);
        border-radius: 2.4rem;

        .modal-base-heading {
            display: flex;
            flex-direction: column;
            gap: 2rem;
            padding: 0 2rem;
            margin-bottom: 3rem;

            .modal-base-heading-icon {
                width: 8rem;
                height: 8rem;
                background: #009991;
                border-radius: 2.4rem;
                display: flex;
                align-items: center;
                justify-content: center;

                .icon {
                    fill: var(--color-white);
                }
            }

            .modal-base-heading-headings {
                display: flex;
                flex-direction: column;
                gap: 1rem;
            }

            .default-modal-error {
                color: var(--color-secondary-orange);
                @include font(1.4,1.4,black);
            }
        }
    }

    &.--delete-modal {
        .modal-base-body {
            .modal-base-heading {
                .modal-base-heading-icon {
                    background: var(--color-secondary-orange);
                }
            }
        }
    }

    @include dark() {
        .modal-base-body {
            background: var(--color-darth-vader);

            h1 {
                color: var(--color-white);
            }
        }
    }

    @include mobile() {
        margin: 0;

        .modal-base-body {
            border-radius: 2.4rem 2.4rem 0 0;

            .modal-body-content {
                max-height: calc(100dvh - 30.4rem);
                overflow-y: auto;
            }
        }
    }
}
</style>
